module.exports = __webpack_public_path__ + "prod/1.42.2/img/qqwl.91431ce0.png";